/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Upgrade_TitleInputs */

const en_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to unlock Analytics`)
};

const de_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade, um Analysen freizuschalten`)
};

const fr_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe à un plan supérieur pour débloquer les Analyses`)
};

const es_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejore su plan para desbloquear Análisis`)
};

const it_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna per sbloccare le Analisi`)
};

const nl_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade om Analyses te ontgrendelen`)
};

const pl_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz, aby odblokować Analizy`)
};

const fi_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä avataksesi Analytiikan`)
};

const da_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader for at låse Analyser op`)
};

const sv_analytics_upgrade_title = /** @type {(inputs: Analytics_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera för att låsa upp Analyser`)
};

/**
* | output |
* | --- |
* | "Upgrade to unlock Analytics" |
*
* @param {Analytics_Upgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_upgrade_title = /** @type {((inputs?: Analytics_Upgrade_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Upgrade_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_upgrade_title(inputs)
	if (locale === "fr") return fr_analytics_upgrade_title(inputs)
	if (locale === "es") return es_analytics_upgrade_title(inputs)
	if (locale === "it") return it_analytics_upgrade_title(inputs)
	if (locale === "nl") return nl_analytics_upgrade_title(inputs)
	if (locale === "pl") return pl_analytics_upgrade_title(inputs)
	if (locale === "fi") return fi_analytics_upgrade_title(inputs)
	if (locale === "da") return da_analytics_upgrade_title(inputs)
	if (locale === "sv") return sv_analytics_upgrade_title(inputs)
	return en_analytics_upgrade_title(inputs)
});